
import React, {useEffect, useState} from 'react';

import {FaArrowRight, FaTimes} from 'react-icons/fa';



const Team = () => {
    useEffect(()=>{
document.title = "Beds | Pinnacle Concepts Limited";
},[]);


  return (
    <section className='section-cover team-cover equip-cover' >
         <div className='content-container products-container'>
          
          <h2 className="home-h2 furniture-h2">Beds</h2>
             {/* <p className='about-intro-p'>Exotic Furniture</p> */}
         
            <div className='services-container-new'>
                <article className='single-service-new'>
    
              <div className='tools-slides-cover'>
                {/* <Tool1></Tool1> */}
                <img src='./images/8.jpg' class='item-image item-image-a'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/HF/B/001</h3>
          </article>
                <article className='single-service-new'>
    
              <div className='tools-slides-cover'>
                {/* <Tool1></Tool1> */}
                <img src='./images/9.jpg' class='item-image item-image-a'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/HF/B/002</h3>
          </article>
          <article className='single-service-new'>
    
              <div className='tools-slides-cover'>
                {/* <Tool1></Tool1> */}
                <img src='./images/10.jpg' class='item-image item-image-a'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/HF/B/003</h3>
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/11.jpg' class='item-image item-image-a'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/HF/B/004</h3>
          
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/12.jpg' class='item-image item-image-a'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/HF/B/005</h3>
          
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/13.jpg' class='item-image item-image-a'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/HF/B/006</h3>
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/14.jpg' class='item-image item-image-a'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/HF/B/007</h3>
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/15.jpg' class='item-image item-image-a'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/HF/B/008</h3>
          </article>
        
      </div>
         </div>
    </section>
  )
}

export default Team